import { CopilotKit } from "@copilotkit/react-core";
import { CopilotPopup, CopilotSidebar, CopilotChat } from "@copilotkit/react-ui";
import "@copilotkit/react-ui/styles.css";

function ChatWindow(props) {

    // return (
    //     <>
    //         <div style={{width: `${props.width}px`, height: '100%', textAlign: 'center'}}></div>
    //     </>
    //     );

    const popup = (<>
            <CopilotPopup
                instructions={"You are assisting the user as best as you can. Answer in the best way possible given the data you have."}
                labels={{
                title: "Popup Assistant",
                initial: "Need any help?",
                }}
            />
                    
        </>)

    const sidebar = (<>
        <CopilotSidebar
        labels={{
            title: "Your Assistant",
            initial: "Hi! 👋 How can I assist you today?",
        }}
        /> 
    </>)  

const chat = (<>
    <CopilotChat
        debug={false || undefined}
        labels={{
        title: "Your Assistant",
        initial: "Hi! 👋 How can I assist you today?",
    }}
    />
</>)  

    return (
    <>
        <div style={{width: `${props.width}px`, overflow:'auto', height: '100%', border:'1px solid var(--aixelo-gray)', color:'var(--aixelo-green)', textAlign: 'center'}}>
            <div style={{paddingTop:'10px', paddingBottom:'10px', backgroundColor:'var(--aixelo-gray-light'}}>
                Edison-4.0 Chat
            </div>
                {chat}
        </div>
    </>
    );
}

export default ChatWindow;